export const GLOBAL_DATE_PICKER_CHANGED = 'GLOBAL_DATE_PICKER_CHANGED'
export const datePickerChanged = (value, valueKey = 'global') => {
  return {
    type: GLOBAL_DATE_PICKER_CHANGED,
    value,
    valueKey
  }
}
